module.exports = __webpack_public_path__ + "img/hiperbolicImg.1856e30c.svg";